import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { handleTokenAndPostRequest } from "../utils/utils";
import VendorleadsGradientText from "../components/VendorleadsGradientText";

const BRAND_COLOR = "#1a3f6b";
const BRAND_ACCENT_COLOR = "#10b981";

export default function UnsubscribeAgent() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("idle"); // idle | loading | success | error
  const [errorMsg, setErrorMsg] = useState("");

  const token = searchParams.get("token") || "";
  const campaign = searchParams.get("campaign") || "";

  const handleUnsubscribe = async () => {
    setStatus("loading");
    setErrorMsg("");
    try {
      await handleTokenAndPostRequest(`${window.api_host}/unsubscribe-agent`, {
        campaign,
      });
      setStatus("success");
    } catch (err) {
      console.error("Unsubscribe error:", err);
      setErrorMsg(
        err?.response?.data?.detail ||
          "Something went wrong. Please try again later."
      );
      setStatus("error");
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #f6f8fa 0%, #e9ecef 100%)",
        padding: "1.5rem",
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: 16,
          boxShadow: "0 8px 32px rgba(0,0,0,0.08)",
          maxWidth: 480,
          width: "100%",
          padding: "2.5rem 2rem",
          textAlign: "center",
        }}
      >
        {/* Logo / Brand */}
        <div style={{ marginBottom: "1.5rem" }}>
          <VendorleadsGradientText style={{ fontSize: "1.75rem" }}>
            Vendorleads
          </VendorleadsGradientText>
        </div>

        {status === "success" ? (
          <>
            <div style={{ fontSize: "3rem", marginBottom: "0.75rem" }}>✅</div>
            <h2
              style={{
                color: BRAND_COLOR,
                fontSize: "1.35rem",
                marginBottom: "0.75rem",
              }}
            >
              You've been unsubscribed
            </h2>
            <p style={{ color: "#6b7280", fontSize: "0.95rem", lineHeight: 1.6 }}>
              You will no longer receive <strong>{campaign.replace(/_/g, " ")}</strong>{" "}
              emails.
            </p>
          </>
        ) : (
          <>
            <h2
              style={{
                color: BRAND_COLOR,
                fontSize: "1.35rem",
                marginBottom: "0.75rem",
              }}
            >
              Unsubscribe from emails
            </h2>
            <p
              style={{
                color: "#6b7280",
                fontSize: "0.95rem",
                lineHeight: 1.6,
                marginBottom: "1.5rem",
              }}
            >
              Are you sure you want to unsubscribe from{" "}
              <strong>{campaign.replace(/_/g, " ")}</strong> emails?
            </p>

            {status === "error" && (
              <div
                style={{
                  background: "#fef2f2",
                  color: "#b91c1c",
                  borderRadius: 8,
                  padding: "0.75rem 1rem",
                  fontSize: "0.9rem",
                  marginBottom: "1rem",
                }}
              >
                {errorMsg}
              </div>
            )}

            <button
              onClick={handleUnsubscribe}
              disabled={status === "loading"}
              style={{
                background: status === "loading" ? "#9ca3af" : BRAND_COLOR,
                color: "#fff",
                border: "none",
                borderRadius: 8,
                padding: "0.75rem 2rem",
                fontSize: "1rem",
                fontWeight: 600,
                cursor: status === "loading" ? "not-allowed" : "pointer",
                transition: "background 0.2s",
                width: "100%",
              }}
            >
              {status === "loading" ? "Unsubscribing…" : "Unsubscribe"}
            </button>
          </>
        )}
      </div>
    </div>
  );
}
